import { usePortalLabel, type PortalLabel } from '../usePortalLabel';
import { useFeatureEnabled } from './useFeatureEnabled';

const ADDRESS_VALIDATION_FEATURE_KEYS: Record<PortalLabel, string> = {
  f1: 'ADDRESS_VALIDATION_F1',
  'member-portal': 'ADDRESS_VALIDATION_MEMBER',
  'client-portal': 'ADDRESS_VALIDATION_CLIENT',
};

export function useFeatureAddressValidationMemberPortal(): boolean {
  return useFeatureEnabled(ADDRESS_VALIDATION_FEATURE_KEYS['member-portal']);
}

export function useFeatureAddressValidationClientPortal(): boolean {
  return useFeatureEnabled(ADDRESS_VALIDATION_FEATURE_KEYS['client-portal']);
}

export function useFeatureAddressValidationF1(): boolean {
  return useFeatureEnabled(ADDRESS_VALIDATION_FEATURE_KEYS['f1']);
}

export function getAddressValidationFeatureKeyForPortal(
  portalLabel: PortalLabel,
): string {
  return ADDRESS_VALIDATION_FEATURE_KEYS[portalLabel];
}

export function useFeatureAddressValidationForCurrentPortal(): boolean {
  const f1 = useFeatureAddressValidationF1();
  const member = useFeatureAddressValidationMemberPortal();
  const client = useFeatureAddressValidationClientPortal();
  const label = usePortalLabel();
  if (label === 'client-portal') return client;
  if (label === 'member-portal') return member;
  return f1;
}
